import type { ProductDetailsData } from "@jti/fe-common";

import type { LoyaltyBadgeCopyConfig, LoyaltyRewardCopyConfig } from "@product-details/components/ProductLoyaltyBlock";
import { ReactQueryClientProvider } from "@product-details/providers/ReactQueryClientProvider";

import { StandardProductDetails } from "./components";

type StandardProductDetailsContainerProps = ProductDetailsData & {
  loyaltyBadgeCopy?: LoyaltyBadgeCopyConfig;
  loyaltyRewardCopy?: LoyaltyRewardCopyConfig;
  hasLoyaltyDiscountBadge?: boolean;
  isLoyaltyRewardCopyAuthoringEnabled?: boolean;
};

export const StandardProductDetailsContainer = (props: StandardProductDetailsContainerProps) => (
  <ReactQueryClientProvider>
    <StandardProductDetails {...props} />
  </ReactQueryClientProvider>
);
